export const PromiseStatus = {
    Resolved: "resolved",
    Rejected: "rejected",
    Timeout: "timeout"
};
export const withTimeout = (promise, ms)=>{
    const timeoutPromise = new Promise((resolve)=>setTimeout(()=>resolve({
                status: PromiseStatus.Timeout
            }), ms));
    return Promise.race([
        promise.then((value)=>({
                status: PromiseStatus.Resolved,
                value
            }), (reason)=>({
                status: PromiseStatus.Rejected,
                reason
            })),
        timeoutPromise
    ]);
};
